import { Injectable } from '@angular/core';

/**
 * Centralized regex patterns for form validations and string checks.
 *
 * Notes:
 * - These regex patterns should be reused across the application to ensure
 *   consistent validation logic.
 */
@Injectable({
  providedIn: 'root',
})
export class RegexUtilityService {
  static readonly NonWhitespace = /.*\S.*/;
  static readonly Email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
  static readonly Min8Chars = /^.{8,}$/;
  static readonly Min10Chars = /^.{10,}$/;
  static readonly CharsNumbs = /^[a-zA-Z0-9]*$/;
}
